import { produce } from 'immer';
import { devtools } from 'zustand/middleware';
import create from 'zustand/vanilla';
// https://github.com/pmndrs/zustand#middleware
const immerMiddleware = (config, developmentMode) => (set, get, api) => config((fn) => {
    if (developmentMode && fn.name === '') {
        throw Error("Unnamed function used when calling 'set'. This results in a poor debugging experience, please use named functions.");
    }
    return set(produce(fn), true, fn.name);
}, get, api);
function createActionsBoundToStore(store, actions) {
    const newActions = Object.assign({}, actions);
    for (const [key, value] of Object.entries(actions)) {
        if (typeof value === 'function') {
            newActions[key] = value.bind(store);
        }
    }
    return newActions;
}
export function createStore(initialState, actionsCreator, storeName, developmentMode = false) {
    let actions;
    let config = immerMiddleware((set, get) => {
        actions = actionsCreator?.(set, get) ?? {};
        return initialState;
    }, developmentMode);
    if (developmentMode) {
        config = devtools(config, storeName);
    }
    const store = create(config);
    const boundActions = createActionsBoundToStore(store, actions);
    return Object.assign(store, boundActions);
}
